import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'

import { usePanelData } from 'modules/finance/components/FinancialWorkspace/components/ResponsivePageWithPanel/dataProvider'
import { usePanel } from 'modules/finance/components/FinancialWorkspace/components/ResponsivePageWithPanel/provider'
import { PanelData } from 'modules/finance/components/FinancialWorkspaceEmployeeCosts/components/HistoryPanel'

export const useOnClickHeader = () => {
  const { open, setOpen } = usePanel()
  const { data, setData } = usePanelData<PanelData>()

  const onClick = useUnsafeCallback((date: moment.Moment) => {
    setData({
      label: date.format('MMMM YYYY'),
      chartLabel: date.format('MMM YYYY'),
      endDate: date.clone().endOf('month').format('YYYY-MM-DD'),
      startDate: date.clone().startOf('month').format('YYYY-MM-DD'),
    })
    setOpen(true)
  }, [setData, setOpen])

  useUnsafeEffect(() => {
    if (!open) setData({ ...data, chartLabel: undefined })
  }, [open, setData])

  return onClick
}
